import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, BriefcaseBusiness, MapPin } from "lucide-react";
const opportunities = [{
  category: "Financial Programs & Reporting",
  title: "Financial Program and Reporting Lead",
  location: "Thunder Bay, Ontario",
  type: "Full-Time",
  status: "Open Until Filled",
  isFilled: false,
  summary: "Senior financial and reporting role supporting funding accountability, year-end reporting, financial files, and practical client systems.",
  href: "/financial-program-and-reporting-lead/"
}, {
  category: "Client Financial Support",
  title: "Client Financial Administration Lead",
  location: "Thunder Bay, Ontario",
  type: "Full-Time",
  status: "Open Until Filled",
  isFilled: false,
  summary: "Execution-focused role supporting client follow-up, reporting coordination, coding review, funding documentation, and file tracking.",
  href: "/client-financial-administration-lead/"
}, {
  category: "Systems & Technology",
  title: "Microsoft SharePoint and Systems Developer",
  location: "Thunder Bay, Hybrid, or Project-Based",
  type: "Flexible",
  status: "Position Filled",
  isFilled: true,
  summary: "Technology-focused role helping build practical SharePoint, Microsoft 365, workflow, document-management, and reporting tools.",
  href: "/microsoft-sharepoint-and-systems-developer/"
}, {
  category: "Future Opportunities",
  title: "General Expression of Interest",
  location: "Thunder Bay, Ontario",
  type: "Varies by Role",
  status: "Always Open",
  isFilled: false,
  summary: "Interested in meaningful client work, practical problem-solving, and a different kind of professional environment? We welcome introductions.",
  href: "/general-expression-of-interest/"
}];
export default function GuidingPrinciples() {
  return <section data-section-id="256493" id="current-opportunities" className="bg-primary-900 text-white py-16 md:py-24 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <div className="h-1 w-12 bg-secondary-400 mx-auto mb-6 rounded-full" />

          <p className="text-secondary-300 font-default font-semibold tracking-[0.18em] uppercase text-xs block mb-4">
            Current Opportunities
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-white mb-5 leading-tight tracking-tight">
            Roles for practical, thoughtful people.
          </h2>

          <p className="text-primary-100/80 font-default text-base md:text-lg leading-relaxed">
            We are looking for people who want meaningful work, clear
            expectations, creative problem-solving, and a workplace that does
            not rely on the traditional tax-season crunch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 lg:gap-6">
          {opportunities.map((opportunity, i) => <Card key={i} data-index={i} className={`bg-white border shadow-sm rounded-2xl transition-all h-full ${opportunity.isFilled ? "border-border opacity-85" : "border-white/10 hover:shadow-lg hover:-translate-y-1"}`}>
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-start justify-between gap-3 mb-5">
                  <div className={`rounded-xl p-3 ${opportunity.isFilled ? "bg-muted text-muted-foreground" : "bg-secondary-50 text-secondary-600"}`}>
                    <BriefcaseBusiness className="w-5 h-5" />
                  </div>

                  <span className={`text-[11px] uppercase tracking-wide font-semibold px-3 py-1 rounded-full text-right ${opportunity.isFilled ? "text-muted-foreground bg-muted" : "text-secondary-700 bg-secondary-50"}`}>
                    {opportunity.status}
                  </span>
                </div>

                <p className={`font-default font-bold uppercase tracking-[0.16em] text-[11px] mb-3 ${opportunity.isFilled ? "text-muted-foreground" : "text-secondary-700"}`}>
                  {opportunity.category}
                </p>

                <h3 className="text-primary-900 font-default font-bold text-xl leading-tight mb-4">
                  {opportunity.title}
                </h3>

                <div className="space-y-2 mb-5 text-sm text-muted-foreground">
                  <div className="flex items-start gap-2">
                    <MapPin className={`w-4 h-4 shrink-0 mt-0.5 ${opportunity.isFilled ? "text-muted-foreground" : "text-secondary-600"}`} />
                    <span>{opportunity.location}</span>
                  </div>

                  <div className="flex items-start gap-2">
                    <BriefcaseBusiness className={`w-4 h-4 shrink-0 mt-0.5 ${opportunity.isFilled ? "text-muted-foreground" : "text-secondary-600"}`} />
                    <span>{opportunity.type}</span>
                  </div>
                </div>

                <p className="text-muted-foreground font-default text-sm leading-relaxed mb-6">
                  {opportunity.summary}
                </p>

                {opportunity.isFilled ? <>
                    <div className="mt-auto rounded-md bg-muted border border-border p-4">
                      <p className="text-primary-900 font-default font-semibold text-sm mb-1">
                        This position has been filled.
                      </p>

                      <p className="text-muted-foreground font-default text-sm leading-relaxed">
                        Thank you to everyone who expressed interest. Please
                        visit our Career Opportunities page for current and
                        future openings.
                      </p>
                    </div>

                    <span className="mt-5 inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-border text-muted-foreground rounded-md text-xs font-semibold cursor-not-allowed bg-muted/60">
                      Position Filled
                    </span>
                  </> : <a href={opportunity.href} className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-secondary-600 text-secondary-700 rounded-md text-xs font-semibold hover:bg-secondary-50 transition-colors">
                    View Details
                    <ArrowRight className="w-3.5 h-3.5" />
                  </a>}
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}